import { GearTransaction } from './Transaction.js';

class GearBalance extends GearTransaction {
    async findOut(publicKey) {
        const { data: balance } = (await this._api.query.system.account(publicKey));
        return this._api.createType('Balance', balance.free);
    }
    transfer(to, value) {
        this.extrinsic = this._api.tx.balances.transfer(to, value);
        return this.extrinsic;
    }
}

export { GearBalance };
